<template>
    <div>
        <v-row class="pa-0" no-gutters>
            <v-col cols="12" class="pa-4 pt-8">
                <h3 class="pa-0">News-Übersicht</h3>
            </v-col>
            <v-col cols="12" class="pa-0">
                <NewsItem @click="clickNewArticle" :item="item" v-for="(item, index) in news" :key="index" :type="index==0?'big':'default'"></NewsItem>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import {firebase} from '../main';
import NewsItem from '@/components/design/NewsItem';

export default {
    data() {
        return {
            news: []
        }
    },
    methods: {
        clickNewArticle(item) {
            if(item.hasOwnProperty("url")) {
                window.open(item.url, "_blank");
            }
        }
    },
    firestore() {
        return {
            news: firebase.firestore().collection("news").orderBy("timestamp", "desc")
        }
    },
    components: {
        NewsItem
    }
}
</script>